import { ProtectedComponent } from '@components'

import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenConnectBankModal } from '@features/bankAccounts/hooks/useOpenConnectBankModal'
import { BankIntegrationContextProvider } from '@features/openBanking/contexts/bankIntegrationContext'
import { UiSource } from '@features/reconciliation/enums'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { Scope } from '../../../../../../enums/scope'

export const BankAccountSideActions = (): ReactElement => {
  const { t } = useTranslation()
  const openConnectBankModal = useOpenConnectBankModal()
  const { organization } = useUserOrganization()

  const handleConnectToBank = useCallback(() => {
    openConnectBankModal(UiSource.AccountPageCta)
  }, [openConnectBankModal])

  return (
    <BankIntegrationContextProvider organizationId={organization?.id ?? ''}>
      <ProtectedComponent scopes={Scope.BankSyncWrite}>
        <Button active variant="outlined" icon="bank" onClick={handleConnectToBank}>
          {t('bank.accounts.list.card.actions.connect')}
        </Button>
      </ProtectedComponent>
    </BankIntegrationContextProvider>
  )
}
